import templateUrl from './schedule-event-detail.component.html';

export const ScheduleEventDetailComponent = {
    templateUrl,
    bindings: {
        scheduleEvent: "<"
    }
};

export const ScheduleEventDetailModal = {
    component: "apexScheduleEventDetailModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}
